import { render, staticRenderFns } from "./MessageWallScreen.vue?vue&type=template&id=d7967462&scoped=true"
import script from "./MessageWallScreen.vue?vue&type=script&lang=js"
export * from "./MessageWallScreen.vue?vue&type=script&lang=js"
import style0 from "./MessageWallScreen.vue?vue&type=style&index=0&id=d7967462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7967462",
  null
  
)

export default component.exports